import select from "dom-select";
import { classy as cl } from "./classy";

// Accordion for FAQ blocks. Unlike Spoilers, opening one answer never closes the
// others. Toggling is driven by the question <button> so keyboard operation
// (Enter/Space) comes for free; aria-expanded reflects state for assistive tech.
const Faqs = function (parent, openTime) {
  openTime = openTime || 400;
  parent = typeof parent === "string" ? select(parent) : parent ? parent : document.body;

  var questions = select.all(".faq-question", parent);

  // The answer's child is absolutely positioned while collapsed, so its natural
  // height can always be measured regardless of the panel's current height.
  function height(content) {
    return content && content.children[0]
      ? content.children[0].getBoundingClientRect().height
      : 0;
  }

  function open(btn, content) {
    btn.setAttribute("aria-expanded", "true");
    cl(btn).addCl("active");
    content.style.height = height(content) + "px";
    cl(content).addCl("active");
    setTimeout(function () {
      content.style.height = "";
    }, openTime);
  }

  function close(btn, content) {
    btn.setAttribute("aria-expanded", "false");
    content.style.height = height(content) + "px";
    cl(btn).rmCl("active");
    cl(content).rmCl("active");
    // Force a reflow so the browser animates from the fixed height back to 0.
    void content.offsetHeight;
    content.style.height = "";
  }

  questions.forEach(function (btn) {
    // Guard against binding the same button twice if this runs again on a page — duplicate listeners would toggle aria-expanded back and
    // forth on a single click and the panel would never open.
    if (btn.dataset.faqBound) return;
    btn.dataset.faqBound = "1";

    var id = btn.getAttribute("aria-controls");
    var content = id ? select("#" + id, parent) : null;
    if (!content) return;

    btn.addEventListener("click", function () {
      if (btn.getAttribute("aria-expanded") === "true") {
        close(btn, content);
      } else {
        open(btn, content);
      }
    });
  });
};

export default Faqs;
